/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  AppointmentScrollQuery,
  AvailabilityScheduleResponse,
  BookClassRoomRequest,
  BulkAppointmentBookingRequest,
  BulkAppointmentBookingResponse,
  CreateAppointmentRequest,
  GetAppointmentBookingResponse,
  GetAppointmentResponse,
  GetBulkAppointmentBookingsRequest,
  GetBulkAppointmentBookingsResponse,
  PaginatedResultOfGetAppointmentResponse,
  Result,
  ResultOfCreateAppointmentResponse,
  UpdateAppointmentRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    AppointmentScrollQueryFromJSON,
    AppointmentScrollQueryToJSON,
    AvailabilityScheduleResponseFromJSON,
    AvailabilityScheduleResponseToJSON,
    BookClassRoomRequestFromJSON,
    BookClassRoomRequestToJSON,
    BulkAppointmentBookingRequestFromJSON,
    BulkAppointmentBookingRequestToJSON,
    BulkAppointmentBookingResponseFromJSON,
    BulkAppointmentBookingResponseToJSON,
    CreateAppointmentRequestFromJSON,
    CreateAppointmentRequestToJSON,
    GetAppointmentBookingResponseFromJSON,
    GetAppointmentBookingResponseToJSON,
    GetAppointmentResponseFromJSON,
    GetAppointmentResponseToJSON,
    GetBulkAppointmentBookingsRequestFromJSON,
    GetBulkAppointmentBookingsRequestToJSON,
    GetBulkAppointmentBookingsResponseFromJSON,
    GetBulkAppointmentBookingsResponseToJSON,
    PaginatedResultOfGetAppointmentResponseFromJSON,
    PaginatedResultOfGetAppointmentResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateAppointmentResponseFromJSON,
    ResultOfCreateAppointmentResponseToJSON,
    UpdateAppointmentRequestFromJSON,
    UpdateAppointmentRequestToJSON,
} from '../models/index';

export interface ApiAppointmentTypesGetRequest {
    xTenantID?: number;
}

export interface ApiAppointmentsBookPostRequest {
    bulkAppointmentBookingRequest: BulkAppointmentBookingRequest;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdAvailableRoomsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdBookClassroomPutRequest {
    id: number;
    bookClassRoomRequest: BookClassRoomRequest;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdCancelPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdConfirmPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingIdRejectPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingsBulkPostRequest {
    getBulkAppointmentBookingsRequest: GetBulkAppointmentBookingsRequest;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingsByStudentStudentIdGetRequest {
    studentId: number;
    xTenantID?: number;
}

export interface ApiAppointmentsBookingsByUserUserIdGetRequest {
    userId: number;
    xTenantID?: number;
}

export interface ApiAppointmentsIdBookingsDeleteRequest {
    id: number;
    apiUserTasksGetLastSelectedIdParameter: Array<ApiUserTasksGetLastSelectedIdParameter>;
    xTenantID?: number;
}

export interface ApiAppointmentsIdBookingsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsIdScheduleGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAppointmentsPostRequest {
    createAppointmentRequest: CreateAppointmentRequest;
    xTenantID?: number;
}

export interface ApiAppointmentsPutRequest {
    updateAppointmentRequest: UpdateAppointmentRequest;
    xTenantID?: number;
}

export interface ApiAppointmentsScrollPostRequest {
    appointmentScrollQuery: AppointmentScrollQuery;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface GetAppointmentByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class PrivatesAppointmentsApi extends runtime.BaseAPI {

    /**
     * Get appointment types
     */
    async apiAppointmentTypesGetRaw(requestParameters: ApiAppointmentTypesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointment/types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentResponseFromJSON));
    }

    /**
     * Get appointment types
     */
    async apiAppointmentTypesGet(requestParameters: ApiAppointmentTypesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentResponse>> {
        const response = await this.apiAppointmentTypesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Books the appointment for specified appointment IDs
     * Book multiple appointments
     */
    async apiAppointmentsBookPostRaw(requestParameters: ApiAppointmentsBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkAppointmentBookingResponse>> {
        if (requestParameters['bulkAppointmentBookingRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkAppointmentBookingRequest',
                'Required parameter "bulkAppointmentBookingRequest" was null or undefined when calling apiAppointmentsBookPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/book`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkAppointmentBookingRequestToJSON(requestParameters['bulkAppointmentBookingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkAppointmentBookingResponseFromJSON(jsonValue));
    }

    /**
     * Books the appointment for specified appointment IDs
     * Book multiple appointments
     */
    async apiAppointmentsBookPost(requestParameters: ApiAppointmentsBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkAppointmentBookingResponse> {
        const response = await this.apiAppointmentsBookPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available rooms
     */
    async apiAppointmentsBookingIdAvailableRoomsGetRaw(requestParameters: ApiAppointmentsBookingIdAvailableRoomsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAppointmentBookingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdAvailableRoomsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}/available-rooms`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAppointmentBookingResponseFromJSON(jsonValue));
    }

    /**
     * Get available rooms
     */
    async apiAppointmentsBookingIdAvailableRoomsGet(requestParameters: ApiAppointmentsBookingIdAvailableRoomsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAppointmentBookingResponse> {
        const response = await this.apiAppointmentsBookingIdAvailableRoomsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Book classroom for appointment
     */
    async apiAppointmentsBookingIdBookClassroomPutRaw(requestParameters: ApiAppointmentsBookingIdBookClassroomPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdBookClassroomPut().'
            );
        }

        if (requestParameters['bookClassRoomRequest'] == null) {
            throw new runtime.RequiredError(
                'bookClassRoomRequest',
                'Required parameter "bookClassRoomRequest" was null or undefined when calling apiAppointmentsBookingIdBookClassroomPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}/book-classroom`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BookClassRoomRequestToJSON(requestParameters['bookClassRoomRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Book classroom for appointment
     */
    async apiAppointmentsBookingIdBookClassroomPut(requestParameters: ApiAppointmentsBookingIdBookClassroomPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsBookingIdBookClassroomPutRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel appointment booking
     */
    async apiAppointmentsBookingIdCancelPutRaw(requestParameters: ApiAppointmentsBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdCancelPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel appointment booking
     */
    async apiAppointmentsBookingIdCancelPut(requestParameters: ApiAppointmentsBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsBookingIdCancelPutRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm appointment booking
     */
    async apiAppointmentsBookingIdConfirmPutRaw(requestParameters: ApiAppointmentsBookingIdConfirmPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdConfirmPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}/confirm`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm appointment booking
     */
    async apiAppointmentsBookingIdConfirmPut(requestParameters: ApiAppointmentsBookingIdConfirmPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsBookingIdConfirmPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get appointment booking by ID
     */
    async apiAppointmentsBookingIdGetRaw(requestParameters: ApiAppointmentsBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAppointmentBookingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAppointmentBookingResponseFromJSON(jsonValue));
    }

    /**
     * Get appointment booking by ID
     */
    async apiAppointmentsBookingIdGet(requestParameters: ApiAppointmentsBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAppointmentBookingResponse> {
        const response = await this.apiAppointmentsBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject appointment booking
     */
    async apiAppointmentsBookingIdRejectPutRaw(requestParameters: ApiAppointmentsBookingIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsBookingIdRejectPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/booking/{id}/reject`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject appointment booking
     */
    async apiAppointmentsBookingIdRejectPut(requestParameters: ApiAppointmentsBookingIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsBookingIdRejectPutRaw(requestParameters, initOverrides);
    }

    /**
     * Returns upcoming bookings for up to 100 appointment IDs in one request. Empty or null appointmentIds returns { items: [] }. Unknown IDs (including other-tenant) are included with bookings: []. Same authorization as GET /api/appointments/{id}/bookings (class [Authorize] plus EF tenant filter). Does not create bookings.
     * Get appointment bookings in bulk
     */
    async apiAppointmentsBookingsBulkPostRaw(requestParameters: ApiAppointmentsBookingsBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBulkAppointmentBookingsResponse>> {
        if (requestParameters['getBulkAppointmentBookingsRequest'] == null) {
            throw new runtime.RequiredError(
                'getBulkAppointmentBookingsRequest',
                'Required parameter "getBulkAppointmentBookingsRequest" was null or undefined when calling apiAppointmentsBookingsBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/bookings/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBulkAppointmentBookingsRequestToJSON(requestParameters['getBulkAppointmentBookingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBulkAppointmentBookingsResponseFromJSON(jsonValue));
    }

    /**
     * Returns upcoming bookings for up to 100 appointment IDs in one request. Empty or null appointmentIds returns { items: [] }. Unknown IDs (including other-tenant) are included with bookings: []. Same authorization as GET /api/appointments/{id}/bookings (class [Authorize] plus EF tenant filter). Does not create bookings.
     * Get appointment bookings in bulk
     */
    async apiAppointmentsBookingsBulkPost(requestParameters: ApiAppointmentsBookingsBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBulkAppointmentBookingsResponse> {
        const response = await this.apiAppointmentsBookingsBulkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all appointment bookings associated with a specific student ID.
     * Get appointment bookings by student ID
     */
    async apiAppointmentsBookingsByStudentStudentIdGetRaw(requestParameters: ApiAppointmentsBookingsByStudentStudentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentBookingResponse>>> {
        if (requestParameters['studentId'] == null) {
            throw new runtime.RequiredError(
                'studentId',
                'Required parameter "studentId" was null or undefined when calling apiAppointmentsBookingsByStudentStudentIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/bookings/by-student/{studentId}`;
        urlPath = urlPath.replace(`{${"studentId"}}`, encodeURIComponent(String(requestParameters['studentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentBookingResponseFromJSON));
    }

    /**
     * Retrieves all appointment bookings associated with a specific student ID.
     * Get appointment bookings by student ID
     */
    async apiAppointmentsBookingsByStudentStudentIdGet(requestParameters: ApiAppointmentsBookingsByStudentStudentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentBookingResponse>> {
        const response = await this.apiAppointmentsBookingsByStudentStudentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all appointment bookings associated with a specific user ID.
     * Get appointment bookings by user ID
     */
    async apiAppointmentsBookingsByUserUserIdGetRaw(requestParameters: ApiAppointmentsBookingsByUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentBookingResponse>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiAppointmentsBookingsByUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/bookings/by-user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentBookingResponseFromJSON));
    }

    /**
     * Retrieves all appointment bookings associated with a specific user ID.
     * Get appointment bookings by user ID
     */
    async apiAppointmentsBookingsByUserUserIdGet(requestParameters: ApiAppointmentsBookingsByUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentBookingResponse>> {
        const response = await this.apiAppointmentsBookingsByUserUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete multiple appointment bookings
     */
    async apiAppointmentsIdBookingsDeleteRaw(requestParameters: ApiAppointmentsIdBookingsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsIdBookingsDelete().'
            );
        }

        if (requestParameters['apiUserTasksGetLastSelectedIdParameter'] == null) {
            throw new runtime.RequiredError(
                'apiUserTasksGetLastSelectedIdParameter',
                'Required parameter "apiUserTasksGetLastSelectedIdParameter" was null or undefined when calling apiAppointmentsIdBookingsDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/{id}/bookings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['apiUserTasksGetLastSelectedIdParameter']!.map(ApiUserTasksGetLastSelectedIdParameterToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete multiple appointment bookings
     */
    async apiAppointmentsIdBookingsDelete(requestParameters: ApiAppointmentsIdBookingsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsIdBookingsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get appointment bookings
     */
    async apiAppointmentsIdBookingsGetRaw(requestParameters: ApiAppointmentsIdBookingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAppointmentBookingResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsIdBookingsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/{id}/bookings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAppointmentBookingResponseFromJSON));
    }

    /**
     * Get appointment bookings
     */
    async apiAppointmentsIdBookingsGet(requestParameters: ApiAppointmentsIdBookingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAppointmentBookingResponse>> {
        const response = await this.apiAppointmentsIdBookingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete appointment
     */
    async apiAppointmentsIdDeleteRaw(requestParameters: ApiAppointmentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete appointment
     */
    async apiAppointmentsIdDelete(requestParameters: ApiAppointmentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the availability schedule for a specific appointment by its ID. The response can be cached by the client for 2 minutes.
     * Appointment schedule
     */
    async apiAppointmentsIdScheduleGetRaw(requestParameters: ApiAppointmentsIdScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailabilityScheduleResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAppointmentsIdScheduleGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/{id}/schedule`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AvailabilityScheduleResponseFromJSON));
    }

    /**
     * Retrieves the availability schedule for a specific appointment by its ID. The response can be cached by the client for 2 minutes.
     * Appointment schedule
     */
    async apiAppointmentsIdScheduleGet(requestParameters: ApiAppointmentsIdScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailabilityScheduleResponse>> {
        const response = await this.apiAppointmentsIdScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new appointment using the provided request data
     * Create appointment
     */
    async apiAppointmentsPostRaw(requestParameters: ApiAppointmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateAppointmentResponse>> {
        if (requestParameters['createAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentRequest',
                'Required parameter "createAppointmentRequest" was null or undefined when calling apiAppointmentsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentRequestToJSON(requestParameters['createAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateAppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new appointment using the provided request data
     * Create appointment
     */
    async apiAppointmentsPost(requestParameters: ApiAppointmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateAppointmentResponse> {
        const response = await this.apiAppointmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update appointment
     */
    async apiAppointmentsPutRaw(requestParameters: ApiAppointmentsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentRequest',
                'Required parameter "updateAppointmentRequest" was null or undefined when calling apiAppointmentsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentRequestToJSON(requestParameters['updateAppointmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update appointment
     */
    async apiAppointmentsPut(requestParameters: ApiAppointmentsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppointmentsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Returns a paginated list of available appointments matching the specified filters.
     * Fetch appointments
     */
    async apiAppointmentsScrollPostRaw(requestParameters: ApiAppointmentsScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetAppointmentResponse>> {
        if (requestParameters['appointmentScrollQuery'] == null) {
            throw new runtime.RequiredError(
                'appointmentScrollQuery',
                'Required parameter "appointmentScrollQuery" was null or undefined when calling apiAppointmentsScrollPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentScrollQueryToJSON(requestParameters['appointmentScrollQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetAppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of available appointments matching the specified filters.
     * Fetch appointments
     */
    async apiAppointmentsScrollPost(requestParameters: ApiAppointmentsScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetAppointmentResponse> {
        const response = await this.apiAppointmentsScrollPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get appointment
     */
    async getAppointmentByIdRaw(requestParameters: GetAppointmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAppointmentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAppointmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/appointments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Get appointment
     */
    async getAppointmentById(requestParameters: GetAppointmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAppointmentResponse> {
        const response = await this.getAppointmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
